// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import styles from './form.module.less';
import {t_methods} from './types';
import {www_hola} from 'hola_opt';
import {Method_button} from './method_button';
import Icon_appstore_logo from '../../img/svg/icon/appstore_logo.svg';
import Email_icon from '../../img/hola2023/icons/16/email_icon.svg';
import Google_icon from '../../../../util/pub/img/icon_google2.svg';
import Github_icon from '../../../../toolip/pub/img/github.svg';
import {Svg} from '../svg';

interface i_buttons_props {
    type: 'login'|'signup';
    on_click: (type:t_methods)=>void;
    blocks: {
        social?: {[propname: string]: boolean},
    }
}

export const Buttons = (props: i_buttons_props)=>{
    // const {block_google_login} = use_qs();
    // const is_toolip = location.host == 'toolip.io';
    const login_conf = www_hola.login || {};
    const social = {
        ...login_conf.all?.social || {},
        ...login_conf[location.hostname]?.social || {},
        ...props.blocks?.social || {},
    };
    const show_google_method = !social.hide && !social.hide_google;
    // const block_google_login_ = www_hola.block_google_login
    //    || block_google_login;
    const show_fb_method = !social.hide && !social.hide_fb;
    const show_apple_method = !social.hide && !social.hide_apple;
    const show_github_method = !social.hide && !social.hide_github;
    const signup_mode = props.type=='signup';
    return <div className={styles.set_of_buttons}>
      {show_google_method && <Method_button type={'google'}
        on_click={props.on_click} signup_mode={signup_mode}>
        <Svg icon={<Google_icon width={16} height={16}/>}/>
      </Method_button>}
      {show_github_method && <Method_button type="github"
        on_click={props.on_click} signup_mode={signup_mode}>
        <Svg icon={<Github_icon width={16} height={16}/>}/>
      </Method_button>}
      {show_fb_method && <Method_button type={'facebook'}
        on_click={props.on_click} signup_mode={signup_mode}/>}
      <Method_button type={'email'} on_click={props.on_click}
        signup_mode={signup_mode}>
        <Svg icon={<Email_icon width={16} height={16}/>}/>
      </Method_button>
      {show_apple_method && <Method_button type="apple"
        on_click={props.on_click} signup_mode={signup_mode}>
        <Svg icon={<Icon_appstore_logo width={16} height={16}/>}/>
      </Method_button>}
    </div>;
};
